import { IMenu } from "interfaces/IMenu"
import CardOption from "overrides/theme/entel/base/components/Summary/SummaryOption/CardOption"
import { getStatusTranslateValue } from "overrides/theme/entel/base/helpers/status_helper"

const SummaryOptions = ({
  summaryOptions,
  current_shipping_type,
}: {
  summaryOptions: IMenu[]
  current_shipping_type: string
}) => {
  // console.log("summaryOptions", summaryOptions)
  return (
    <>
      {summaryOptions.map(({ optionCount, path, title, status }, index) => {
        if (!getStatusTranslateValue(title, current_shipping_type)?.title) return null
        return (
          <CardOption
            index={index}
            key={`${path}-${title}`}
            optionCount={optionCount}
            path={path}
            title={title}
            status={status}
            current_shipping_type={current_shipping_type}
          />
        )
      })}
    </>
  )
}

export default SummaryOptions
